/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelattachnone2Inputs */

const en_channelattachnone2 = /** @type {(inputs: Channelattachnone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const de_channelattachnone2 = /** @type {(inputs: Channelattachnone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keiner`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Channelattachnone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelattachnone2 = /** @type {((inputs?: Channelattachnone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelattachnone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelattachnone2(inputs)
	return de_channelattachnone2(inputs)
});
export { channelattachnone2 as "channelAttachNone" }